module.exports = __webpack_public_path__ + "img/EventManager-dark.c24f6215.svg";